import { MaintenanceWindowSchedulerWebComponent } from './component/MaintenanceWindowSchedulerWebComponent';
import { WEB_COMPONENT_MAINTENANCE_WINDOW_SCHEDULER } from '../../webcomponents.constants';

export { MaintenanceWindowSchedulerWebComponent };

window.customElements.define(WEB_COMPONENT_MAINTENANCE_WINDOW_SCHEDULER, MaintenanceWindowSchedulerWebComponent);
